import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets//img//imagesd.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-3c42aa5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row row-col-auto" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, " Nostros", -1))
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "container-fluid empresas-section" }
const _hoisted_8 = { class: "container-sm" }
const _hoisted_9 = { class: "row justify-content-center gx-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-5 text-center" }, "Nuestras empresas")
], -1))
const _hoisted_11 = { class: "col-md-4 mb-4 text-center" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "row justify-content-center mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-5 text-center" }, "Lo más destacado ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, " Párrafo. Haz clic aquí para agregar tu propio texto y editar. Es fácil. Haz clic en \"Editar texto\" o doble clic aquí para agregar tu contenido y cambiar la fuente. s ", -1))
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "container-sm mt-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img-fluid",
  alt: "..."
}, null, -1))

import Hero from '@/components/Hero.vue';
import Nosotros from '@/components/Nostros.vue'
import CardEmpresas from '@/components/CardEmpresas.vue';
import { Ref, ref } from 'vue';
import { Iempresa } from '@/app/model/empresa';
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

var UrlBackground = 'images.jpeg';
var logo = 'safeguard.png'
var nostrosbg = 'plantas.png';

const empresas: Ref<Iempresa[]> = ref([{
  img: 'covid.png',
  title: 'q',
  subtitle: '',
  colorButon: '#10BF97',
  secondaryColorButon: '#084861',
  textcolor: 'white',
  textcolorbtn: 'white',
  name: 'anticovid'
}, {
  img: 'pest.png',
  title: '',
  subtitle: '',
  colorButon: '#10BF97',
  secondaryColorButon: '#084861',
  textcolor: 'white',
  textcolorbtn: 'white',
  name: 'pest'
}, {
  img: 'premium.png',
  title: '',
  subtitle: '',
  colorButon: '#10BF97',
  secondaryColorButon: '#084861',
  textcolor: 'white',
  textcolorbtn: 'white',
  name: 'lavanderia'
}, {
  img: 'missclean.png',
  title: '',
  subtitle: '',
  colorButon: '#10BF97',
  secondaryColorButon: '#084861',
  textcolor: 'white',
  textcolorbtn: 'white',
  name: 'msclean'
}, {
  img: 'safefire.png',
  title: '',
  subtitle: '',
  colorButon: '#10BF97',
  secondaryColorButon: '#084861',
  textcolor: 'white',
  textcolorbtn: 'white',
  name: ''
}, {
  img: 'rich.png',
  title: '',
  subtitle: '',
  colorButon: '#10BF97',
  secondaryColorButon: '#084861',
  textcolor: 'white',
  textcolorbtn: 'white',
  name: ''
},]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Hero, {
          "back-ground": _unref(UrlBackground),
          logo: _unref(logo),
          "to-scroll": "final",
          btntext: "Contactanos",
          "show-btn": true
        }, null, 8, ["back-ground", "logo"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Nosotros, { "back-ground": _unref(nostrosbg) }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" El objetivo de Grupo Safeguard es brindar servicios de limpieza, desinfección y fumigación de alta calidad para los clientes, siendo responsables con el medio ambiente y apoyando el crecimiento personal y profesional de sus empleados. ")
          ]),
          _: 1
        }, 8, ["back-ground"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(empresas.value, (empresa) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(CardEmpresas, {
                    empresa: empresa,
                    style: {"margin":"auto"}
                  }, null, 8, ["empresa"])
                ]))
              }), 256))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(Carousel), { "items-to-show": 5 }, {
                addons: _withCtx(() => [
                  _createVNode(_unref(Navigation)),
                  _createVNode(_unref(Pagination))
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (slide) => {
                    return _createVNode(_unref(Slide), { key: slide }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 2
                    }, 1024)
                  }), 64))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})